module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.user.email_verified) ? _c('div', {
    staticClass: "text-center",
    attrs: {
      "id": "bound"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('email')) + _vm._s(_vm.$t(':')) + _vm._s(_vm.user.email))]), _vm._v(" "), _c('p', [_c('img', {
    attrs: {
      "src": "/static/img/dashboard/ic_verified.svg",
      "alt": "Your email"
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('bound')))])])]) : _c('div', {
    staticClass: "bind-form"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.email),
      expression: "email",
      modifiers: {
        "trim": true
      }
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    class: [{
      'danger-border': _vm.showEmailError && _vm.emailHasError
    }, 'email'],
    attrs: {
      "type": "email",
      "name": "email",
      "placeholder": _vm.$t('email')
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "focus": function($event) {
        _vm.showEmailError = false
      },
      "blur": [function($event) {
        _vm.showEmailError = true
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.bindEmail($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value.trim()
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "error-info"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showEmailError && _vm.errors.has('email')),
      expression: "showEmailError && errors.has('email')"
    }]
  }, [_vm._v(_vm._s(_vm.errors.first('email')))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showEmailError && !!_vm.emailErrorMessage),
      expression: "showEmailError && !!emailErrorMessage"
    }]
  }, [_vm._v(_vm._s(_vm.emailErrorMessage))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group get-verification-code"
  }, [_c('button', [_c('spinner', {
    staticClass: "spinner-component",
    attrs: {
      "show": _vm.countDown === 0 && _vm.getCodeDisabled
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.countDown === 0 && !_vm.getCodeDisabled),
      expression: "countDown === 0 && !getCodeDisabled"
    }],
    staticClass: "get-code",
    on: {
      "click": _vm.getVerificationCode
    }
  }, [_vm._v(_vm._s(_vm.$t('getVerificationCode')))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.countDown > 0),
      expression: "countDown > 0"
    }],
    staticClass: "wait"
  }, [_vm._v(_vm._s(_vm.$t('wait')) + " " + _vm._s(_vm.countDown) + " s")])], 1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.verificationCode),
      expression: "verificationCode",
      modifiers: {
        "trim": true
      }
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|numeric|digits: 5'),
      expression: "'required|numeric|digits: 5'"
    }],
    class: {
      'danger-border': _vm.codeHasError
    },
    attrs: {
      "autocomplete": "off",
      "type": "text",
      "name": "verificationCode",
      "placeholder": _vm.$t('verificationCode')
    },
    domProps: {
      "value": (_vm.verificationCode)
    },
    on: {
      "focus": function($event) {
        _vm.showCodeError = false
      },
      "blur": [function($event) {
        _vm.showCodeError = true
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.bindEmail($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.verificationCode = $event.target.value.trim()
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "error-info"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showCodeError && _vm.errors.has('verificationCode')),
      expression: "showCodeError && errors.has('verificationCode')"
    }]
  }, [_vm._v(_vm._s(_vm.errors.first('verificationCode')))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showCodeError && !!_vm.codeErrorMessage),
      expression: "showCodeError && !!codeErrorMessage"
    }]
  }, [_vm._v(_vm._s(_vm.codeErrorMessage))])])]), _vm._v(" "), (!_vm.binding) ? _c('button', {
    staticClass: "form-submit",
    on: {
      "click": _vm.bindEmail
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('bind')))])]) : _vm._e(), _vm._v(" "), _c('spinner', {
    staticClass: "spinner-component",
    attrs: {
      "show": _vm.binding
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6c7a4552!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/bindEmail/IndexMain.vue
// module id = 1346
// module chunks = 1